const ProgramTimerSkeleton = () => {
  return (
    <section className="bg-black text-white py-12 px-6 animate-pulse">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

        {/* LEFT CONTENT SKELETON */}
        <div className="space-y-4">
          {/* Title */}
          <div className="h-8 w-3/4 bg-white/20 rounded"></div>

          {/* Description lines */}
          <div className="space-y-2">
            <div className="h-4 w-full bg-white/20 rounded"></div>
            <div className="h-4 w-5/6 bg-white/20 rounded"></div>
            <div className="h-4 w-4/6 bg-white/20 rounded"></div>
          </div>

          {/* Meta info */}
          <div className="space-y-3 mt-4">
            <div className="h-4 w-1/2 bg-white/20 rounded"></div>
            <div className="h-4 w-2/3 bg-white/20 rounded"></div>
            <div className="h-4 w-3/4 bg-white/20 rounded"></div>
          </div>
        </div>

        {/* RIGHT TIMER SKELETON */}
        <div className="flex justify-center md:justify-end">
          <div className="grid grid-cols-4 gap-4">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="bg-white/30 rounded-xl px-4 py-6 min-w-[70px]"
              >
                <div className="h-6 w-full bg-white/60 rounded mb-2"></div>
                <div className="h-3 w-1/2 mx-auto bg-white/50 rounded"></div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ProgramTimerSkeleton;
